import { render } from "./CardDetails.vue?vue&type=template&id=6632d8cd&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=6632d8cd&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6632d8cd"]])

export default __exports__